import { render } from "./CustomConfetti.vue?vue&type=template&id=244e139a&scoped=true&lang=pug"
import script from "./CustomConfetti.vue?vue&type=script&lang=js"
export * from "./CustomConfetti.vue?vue&type=script&lang=js"

import "./CustomConfetti.vue?vue&type=style&index=0&id=244e139a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244e139a"]])

export default __exports__